import { render, staticRenderFns } from "./CheckboxDemo.vue?vue&type=template&id=432b1f4b&scoped=true&"
import script from "./CheckboxDemo.vue?vue&type=script&lang=js&"
export * from "./CheckboxDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432b1f4b",
  null
  
)

export default component.exports